/*
 * CRO test, 2026-09-10b. Wires the advertorial's sticky bar to the buy box.
 *
 * sections/kc3-landing.liquid renders its own sticky bar, .kl-nav, whose CTA is
 * a link to the product page. Now that sections/kc3-buybox-advertorial.liquid
 * puts a real buy box at the top of that same page, sending people to the PDP
 * would walk them away from a buy box they can reach by scrolling. So point the
 * bar at the buy box and keep its label in step with the selected tier.
 *
 * WHY THE LABEL IS SET FROM SCRIPT
 * kc3.js already does exactly this for the PDP's sticky bar: it looks up
 * #stickyBtn globally and rewrites the text on every render(). We cannot just
 * give .kl-nav that id. Both files are `defer`, so they run in document order,
 * and kc3.js -- loaded by the buy box at the top of the page -- captures
 * #stickyBtn before this file has had a chance to set it, and would capture
 * null. So we listen for the kc3:selection event instead (kc3.js dispatches it
 * with bubbles:true, so it reaches document) and do the same work, plus one
 * read of #ctaAmt at startup to catch the first render that fired before this
 * file ran.
 *
 * This is a test scaffold, not the end state. When .kl-nav moves into Liquid
 * with id="stickyBtn" and href="#s-main", delete this file: kc3.js does all of
 * it natively. See cro/DEV-BRIEF-sticky-cta.md.
 *
 * assets/kc-cro.css is unrelated and stays: full-width bar on mobile, and the
 * Gorgias bubble lifted clear of it.
 */
(function () {
  if (window.__kcCroSticky) return;
  window.__kcCroSticky = true;

  var SEL = '.kl-nav .kl-button, .kl-nav .kl-button-small';
  var PREFIX = 'Add to cart · ';

  // Only rewire when the buy box is actually on the page. Advertorials that do
  // not render it keep their existing bar untouched.
  function present() {
    return !!document.getElementById('s-main');
  }

  function buttons() {
    return document.querySelectorAll(SEL);
  }

  function retarget() {
    var els = buttons();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-kc-cro') === '1') continue;
      el.setAttribute('data-kc-cro', '1');
      if (el.tagName === 'A') el.setAttribute('href', '#s-main');
    }
  }

  function label(text) {
    if (!text) return;
    var els = buttons();
    for (var i = 0; i < els.length; i++) {
      // textContent replaces the trailing arrow span too, which is intended.
      els[i].textContent = text;
      els[i].setAttribute('aria-label', text);
    }
  }

  function money(n) {
    return '$' + n.toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function sync(total) {
    if (typeof total === 'number' && isFinite(total)) {
      label(PREFIX + money(total));
      return;
    }
    var amt = document.getElementById('ctaAmt');
    if (amt && amt.textContent.trim()) label(PREFIX + amt.textContent.trim());
  }

  function start() {
    if (!present()) return;
    retarget();
    sync(null);
    document.addEventListener('kc3:selection', function (e) {
      retarget();
      sync(e.detail && e.detail.total);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
